export const RECONNECT_KEY = 'reconnect-wallet-id';
export const RECENT_CONNECTOR_KEY = 'recentConnectorId';
